import { render, staticRenderFns } from "./selectComponent.vue?vue&type=template&id=b194f786&scoped=true"
import script from "./selectComponent.vue?vue&type=script&lang=js"
export * from "./selectComponent.vue?vue&type=script&lang=js"
import style0 from "./selectComponent.vue?vue&type=style&index=0&id=b194f786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b194f786",
  null
  
)

export default component.exports